require('./locationDetails.less');

class LocationDetailsController {
    activeItem;
    selectedIndex = 0;
    zones;
    sumOfAllStocks;

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
        buttons: [
            {materialicon: 'delete', tooltip: 'Slett lokasjon', func: (ev) => this.deleteLocation(ev)}
        ]
    };

    stockUpdateFunction = (val) => {
      this.sumOfAllStocks = val;
    };

    constructor(private toastService, private Locations, private $stateParams, private $mdDialog, private Zones, private $state){
    }

    $onInit() {
        this.Zones.getZones().$promise.then((results) => {
            this.zones = results;
        }, (error) => {
            this.toastService.parseError(error);
        });

        this.Locations.getLocation({locationId: this.$stateParams.locationId}).$promise.then((item) => {
            this.activeItem = item;
            this.toolbarheaderDefinition.toolbarHeading = "Lokasjonsoversikt for " + item.id;
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    updateLocation() {
        this.Locations.updateLocation(
            {locationId: this.activeItem.id},
            {locationType: this.activeItem.type, name: this.activeItem.name, zoneId: this.activeItem.zoneId, blocked: this.activeItem.blocked}).$promise.then(
        () => {}, (error) => {
            this.toastService.parseError(error);
        });
    }

    deleteLocation(ev) {
        const confirm = this.$mdDialog.confirm()
            .title('Slette lokasjon')
            .textContent('Dette vil slette den aktive lokasjonen')
            .ariaLabel('jaja')
            .targetEvent(ev)
            .ok('Slett')
            .cancel('Avbryt');
        this.$mdDialog.show(confirm).then(() => {
            this.Locations.deleteLocation({locationId: this.activeItem.id}).$promise.then(() => {
                this.toastService.showSimpleToast("Lokasjon " + this.activeItem.id + " slettet", 3000);
                this.$state.go("loggedin.expedition_basicdata_locations");
            }, (error) => {
                this.toastService.parseError(error);
            })
        },() => {});
    }
}

class LocationDetailsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcLocationDetailsController";
    public template: any = require('./locationDetails.html');
}

rkcApp.controller("rkcLocationDetailsController", ['toastService', 'Locations', '$stateParams', '$mdDialog', 'Zones', '$state', function(toastService, Locations, $stateParams, $mdDialog, Zones, $state){
    return new LocationDetailsController(toastService, Locations, $stateParams, $mdDialog, Zones, $state);
}])
    .component("rkcLocationDetails", new LocationDetailsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/locations/locationDetails/locationDetails.ts
 **/